import {canPage,canAction} from '../components/ui/PermissionButton';
import {GUIDE_ARTICLES} from './guideContent';

export const GUIDE_ROUTES={erp:'/admindashboard/help',vendor:'/vendordashboard/help',billing:'/billingdashboard/help'};
export function visibleArticles(auth,portal='erp'){
 if(!auth?.user)return [];
 return GUIDE_ARTICLES.filter(a=>{
  if(a.portal==='all')return true;
  if(portal==='vendor'||portal==='billing')return a.portal===portal;
  if(a.portal==='erp'){
   if(['departments','pos-settings'].includes(a.id)&&auth.user.role!=='super_admin')return false;
   return canPage(auth,a.permission,a.path)||(a.id==='menu-form'&&canAction(auth,'menu','edit'));
  }
  if(auth.user.role==='super_admin')return true;
  return a.portal==='billing'&&(auth.permissions||[]).includes('pos.view');
 });
}
export function searchArticles(articles,search='',group='All topics'){
 const terms=search.trim().toLowerCase().split(/\s+/).filter(Boolean);
 return articles.filter(a=>(group==='All topics'||a.group===group)&&terms.every(t=>JSON.stringify([a.title,a.purpose,a.steps,a.fields,a.actions,a.warnings]).toLowerCase().includes(t)));
}
function matches(pattern,path){
 const a=pattern.split('/'),b=path.split('/');
 return a.length===b.length&&a.every((part,index)=>part.startsWith(':')||part===b[index]);
}
export function topicForPath(path){
 if(/^\/admindashboard\/menu-master\/edit\//.test(path))return 'menu-form';
 const exact=GUIDE_ARTICLES.find(a=>a.path===path)||GUIDE_ARTICLES.find(a=>a.path&&matches(a.path,path));
 return exact?.id||'controls';
}
export const GUIDE_WORKFLOWS=[
 {title:'First-time company setup',steps:['branches','departments','roles','staff','inventory','vendors','menu','counters']},
 {title:'Buy through vendor quotations',steps:['vendors','inventory','po-create','po-review','quotations','po-tracking','vendor-payments']},
 {title:'Direct purchase and receipt',steps:['po-create','po-review','po-tracking','vendor-payments']},
 {title:'Store → employee → finished goods',steps:['inventory','material-handover','production','raw-usage','reconciliation']},
 {title:'Restaurant dish → ingredient use → cost',steps:['material-handover','menu-form','billing-sale','kitchen','department-profit']},
 {title:'Customer order → invoice/payment → delivery',steps:['customers','sales-orders','invoices','payments','department-profit']},
 {title:'Employee → attendance → salary → payslip',steps:['staff','attendance','salary','payslips']},
 {title:'Selected-range employee payroll',steps:['attendance','off-cycle','off-cycle-payslips']},
 {title:'Cashier’s day',steps:['billing-start','billing-sale','billing-held','billing-cash','billing-closing']},
 {title:'Supplier’s order lifecycle',steps:['vendor-orders','vendor-deliveries','vendor-payments-portal','vendor-payment-report']}
];
